// 封装一个公共的 HTTP 请求类
import BaseService from "@/api/base";

class SecurityService  extends BaseService {
    // 基础的 API 地址
    private search_path = "/1password/api/v1/secret_key/search"
    private find_last_usable_path = "/1password/api/v1/secret_key/find_last_usable"
    private create_path = "/1password/api/v1/secret_key/create"
    private remove_path = "/1password/api/v1/secret_key/remove"
    private check_last_usable_path = "/1password/api/v1/secret_key/check_last_usable"

    public async findLastUsable(query: any = {}): Promise<any> {
        return await this.getFetchData(this.find_last_usable_path, query);
    }

    // 封装 GET 请求方法
    public async search(query: any = {}): Promise<any> {
        return await this.getFetchData(this.search_path, query);
    }

    public async create(form: any = {}): Promise<any> {
        return await this.postFetchData(this.create_path, form);
    }

    public async remove(form: any = {}): Promise<any> {
        return await this.postFetchData(this.remove_path, form);
    }

    public async checkLastUsable(query: any = {}): Promise<any> {
        return await this.getFetchData(this.check_last_usable_path, query);
    }


}

export default SecurityService;
